import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "report-item"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "icon-title" }
const _hoisted_4 = ["src"]

import { computed, PropType, ref } from "vue";
import { useReportCenterIcon } from './index'
import { EditionType } from '../../download/download.interface'
import tagValueAdded from '@/assets/images/tag-valueAdded.png'
import tagEnhanced from '@/assets/images/tag-enhanced.png'
import {IsZhiHuiXingHe} from "@/core/hooks/SetTheme"

import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: 'ReportIcon'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  iconName: {
    type: String,
    required: true
  },
  iconTitle: {
    type: String,
    required: true
  },
  link: {
    type: String,
    default: ''
  },
  edition: {
    // enhanced --> 加强版 valueAdded--> 增值版
    type: String as PropType<EditionType>,
    default: ''
  }
},
  setup(__props) {

const props = __props

const reportCenterMap = useReportCenterIcon()



const icon = reportCenterMap?.[props.iconName+(IsZhiHuiXingHe()?'-green':'')] || ''


const tag = computed(() => {
  if(props.edition === 'valueAdded') return tagValueAdded
  if(props.edition === 'enhanced') return tagEnhanced
})


return (_ctx: any,_cache: any) => {
  return (!__props.edition)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("img", {
          class: "icon",
          src: _unref(icon),
          alt: ""
        }, null, 8, _hoisted_2),
        _createElementVNode("p", _hoisted_3, _toDisplayString(__props.iconTitle), 1),
        (__props.edition)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "report-tag",
              src: _unref(tag),
              alt: ""
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})